function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
/*! Icon Picker 1.2.1 MIT | https://github.com/AppoloDev/icon-picker */
!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define([], t) : "object" == typeof exports ? exports.IconPicker = t() : e.IconPicker = t();
}(self, () => (() => {
  "use strict";

  var e = {
      d: (t, i) => {
        for (var n in i) e.o(i, n) && !e.o(t, n) && Object.defineProperty(t, n, {
          enumerable: !0,
          get: i[n]
        });
      },
      o: (e, t) => Object.prototype.hasOwnProperty.call(e, t)
    },
    t = {};
  function i(e, t, i, n) {
    Array.isArray(t) || (t = [t]), Array.isArray(i) || (i = [i]);
    for (const s of t) for (const t of i) s[e](t, n);
    return [].slice.call(arguments, 1);
  }
  e.d(t, {
    default: () => m
  });
  const n = i.bind(null, "addEventListener"),
    s = i.bind(null, "removeEventListener");
  function o(e) {
    if (window.DOMParser) {
      return new DOMParser().parseFromString(e, "text/html").body.firstElementChild;
    }
    const t = document.createElement("div");
    return t.innerHTML = e, t.firstElementChild;
  }
  function r(e) {
    return e && "object" == typeof e && !Array.isArray(e);
  }
  function a(e, t) {
    let i = Object.assign({}, e);
    return r(e) && r(t) && Object.keys(t).forEach(n => {
      r(t[n]) ? n in e ? i[n] = a(e[n], t[n]) : Object.assign(i, {
        [n]: t[n]
      }) : Object.assign(i, {
        [n]: t[n]
      });
    }), i;
  }
  function l(e, t) {
    return Object.keys(e).find(i => e[i] === t);
  }
  const c = e => {
    var _s$save;
    const t = e.theme,
      i = e.i18n,
      n = e.closeOnSelect,
      s = function (e) {
        const t = (e, t) => {
            const i = e.getAttribute(t);
            return e.removeAttribute(t), i;
          },
          i = function (e) {
            let n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            const s = t(e, "data-element");
            s && (n[s] = e);
            for (const s of Array.from(e.children)) {
              const e = t(s, "data-interaction");
              e && e && (n[e] = s), i(s, n);
            }
            return n;
          };
        return i(o(e));
      }(`\n        <div class="icon-picker-modal" tabindex="-1" data-theme="${t}" data-element="modal" aria-modal="true" aria-labelledby="Icon picker modal" role="dialog">\n            <div class="icon-picker-modal__dialog">\n                <div class="icon-picker-modal__header" data-element="header">\n                    ${"string" == typeof i["text:title"] && "" !== i["text:title"] ? `<h2>${i["text:title"]}</h2>` : ""}\n                    \n                    <button class="icon-picker-modal--close" aria-label="Close" data-interaction="close">\n                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" stroke-width="1.5">\n                          <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" d="M6.758 17.243 12.001 12m5.243-5.243L12 12m0 0L6.758 6.757M12.001 12l5.243 5.243"/>\n                        </svg>\n                    </button>\n                </div>\n                \n                <input placeholder="${i["input:placeholder"]}" class="icon-picker-modal__search" aria-label="${i["input:placeholder"]}" data-interaction="search">\n                \n                <div class="icon-picker-modal__content" data-element="content"></div>\n            \n                ${n ? "" : `\n                    <div class="icon-picker-modal__footer" data-element="footer">\n                        <button type="button" class="picker-save" data-interaction="save">${i["btn:save"]}</button>\n                    </div>`}\n            </div>\n        </div>\n    `);
    return t.includes("bootstrap") && ((_s$save = s.save) !== null && _s$save !== void 0 && _s$save.classList.add("btn", "btn-primary"), s.search.classList.add("form-control")), s;
  };
  const u = "https://raw.githubusercontent.com/iconify/icon-sets/master/json",
    d = {
      "Material Design Icons": {
        key: "mdi",
        prefix: "mdi mdi-",
        url: `${u}/mdi.json`
      },
      "FontAwesome Brands 6": {
        key: "fa6-brands",
        prefix: "fab fa-",
        url: `${u}/fa6-brands.json`
      },
      "FontAwesome Solid 6": {
        key: "fa6-solid",
        prefix: "fas fa-",
        url: `${u}/fa6-solid.json`
      },
      "FontAwesome Regular 6": {
        key: "fa6-regular",
        prefix: "far fa-",
        url: `${u}/fa6-regular.json`
      },
      Iconoir: {
        key: "iconoir",
        prefix: "iconoir-",
        url: `${u}/iconoir.json`
      }
    };
  function h(e) {
    let t = Object.create({});
    return Array.isArray(e) && e.forEach(e => {
      !function (e) {
        return d.hasOwnProperty(e);
      }(e) ? e.key && (t[e.key] = e) : t[d[e].key] = d[e];
    }), t;
  }
  class m {
    static DEFAULT_OPTIONS = {
      theme: "default",
      closeOnSelect: !0,
      defaultValue: null,
      iconSource: [],
      i18n: {
        "input:placeholder": "Search icon…",
        "text:title": "Select icon",
        "text:empty": "No results found…",
        "btn:save": "Save"
      }
    };
    _eventListener = {
      select: [],
      save: [],
      show: [],
      clear: [],
      hide: []
    };
    constructor(e) {
      let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      this.options = a(m.DEFAULT_OPTIONS, t), this.element = e, this._preBuild(), this.element && this.options.iconSource.length > 0 ? (this._binEvents(), this._renderdIcons(), this._createModal()) : this._catchError("iconSourceMissing");
    }
    _preBuild() {
      var e;
      this.element = (e = this.element) instanceof HTMLElement ? e : "string" == typeof e ? document.querySelector(e) : null, this.root = c(this.options), !Array.isArray(this.options.iconSource) && this.options.iconSource.length > 0 && (this.options.iconSource = [this.options.iconSource]);
    }
    _binEvents() {
      const e = this.options,
        t = this.root,
        i = this.element;
      let s = [];
      var r, a, l;
      this._eventBindings = [n(i, "click", () => this.show()), n(t.close, "click", () => this.hide()), n(t.modal, "click", e => {
        e.target === t.modal && this.hide();
      }), n(t.search, "keyup", (r = i => {
        const n = this.availableIcons.filter(e => {
          var _e$categories;
          return e.value.includes(i.target.value.toLowerCase()) || ((_e$categories = e.categories) === null || _e$categories === void 0 ? void 0 : _e$categories.filter(e => e.includes(i.target.value.toLowerCase())).length) > 0;
        });
        s.length || (s = document.querySelectorAll(".icon-element")), s.forEach(e => {
          e.hidden = !0, n.forEach(t => {
            e.classList.contains(t.value) && (e.hidden = !1);
          });
        });
        const r = t.content.querySelector(".is-empty");
        n.length > 0 ? r && r.remove() : r || t.content.appendChild(o(`<div class="is-empty">${e.i18n["text:empty"]}</div>`));
      }, a = 250, function () {
        var e = arguments,
          t = this;
        clearTimeout(l), l = setTimeout(function () {
          r.apply(t, e);
        }, a);
      }))], e.closeOnSelect || this._eventBindings.push(n(t.save, "click", () => this._onSave()));
    }
    hide() {
      return !!this.isOpen() && (this.root.modal.classList.remove("is-visible"), this._emit("hide"), this);
    }
    show() {
      return !this.isOpen() && (this.root.modal.classList.add("is-visible"), this._emit("show"), this);
    }
    clear() {
      this.initialized && this.currentlySelectName && (this.currentlySelectName = null, this._emit("clear"));
    }
    isOpen() {
      return this.root.modal.classList.contains("is-visible");
    }
    destroy() {
      let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !0;
      this.initialized = !1, this._eventBindings.forEach(e => s(...e)), e && Object.keys(this).forEach(e => delete this[e]);
    }
    _emit(e) {
      for (var _len = arguments.length, t = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        t[_key - 1] = arguments[_key];
      }
      this._eventListener[e].forEach(e => e(...t, this));
    }
    on(e, t) {
      return void 0 !== this._eventListener[e] && (this._eventListener[e].push(t), this);
    }
    off(e, t) {
      const i = this._eventListener[e] || [],
        n = i.indexOf(t);
      return ~n && i.splice(n, 1), this;
    }
    _createModal() {
      document.body.appendChild(this.root.modal), this.initialized = !0;
    }
    _onSave() {
      this._setValueInput(), this.hide(), this._emit("save", this.emitValues);
    }
    async _renderdIcons() {
      const e = this.root,
        t = this.options;
      let i = null,
        n = null,
        s = null;
      if (this.availableIcons = [], e.content.innerHTML = "", (await this._getIcons()).forEach(o => {
        let r = o.iconFormat ? o.iconFormat : "svg";
        for (const _ref of Object.entries(o.icons)) {
          var _ref2 = _slicedToArray(_ref, 2);
          const a = _ref2[0];
          const c = _ref2[1];
          {
            const u = document.createElement("button");
            if (u.title = a, u.className = `icon-element ${a}`, u.dataset.value = o.prefix + a, o.categories && Object.entries(o.categories).length > 0) {
              s = [];
              for (const _ref3 of Object.entries(o.categories)) {
                var _ref4 = _slicedToArray(_ref3, 1);
                const e = _ref4[0];
                o.categories[e].includes(a) && (s.length > 0 ? s.push(e.toLowerCase()) : s = [e.toLowerCase()]);
              }
            }
            let d;
            if (o.chars && (u.dataset.unicode = l(o.chars, a)), "i" !== r && c.body) {
              if ("markup" === r) {
                let e = document.createElement("template");
                e.innerHTML = c.body, d = e.content;
              } else d = document.createElementNS("http://www.w3.org/2000/svg", "svg"), d.setAttribute("height", "24"), d.setAttribute("width", "24"), d.setAttribute("viewBox", `0 0 ${c.width ? c.width : o.width} ${c.height ? c.height : o.height}`), d.innerHTML = c.body;
            } else d = document.createElement("i"), d.setAttribute("class", u.dataset.value);
            u.append(d), e.content.appendChild(u), this.availableIcons.push(_objectSpread({
              value: a,
              body: d.outerHTML
            }, s.length > 0 && {
              categories: s
            })), u.addEventListener("click", e => {
              this.currentlySelectName !== e.currentTarget.firstChild.className && (e.currentTarget.classList.add("is-selected"), n = e.currentTarget, this.currentlySelectName = n.dataset.value, this.SVGString = d.outerHTML, this.emitValues = {
                name: a,
                value: this.currentlySelectName,
                svg: this.SVGString
              }, o.chars && (this.emitValues.unicode = d.dataset.unicode), this._emit("select", this.emitValues)), i && i.classList.remove("is-selected"), t.closeOnSelect && this._onSave(), i = n;
            });
          }
        }
      }), t.defaultValue || this.element.value) {
        var _e$dataset$value;
        let e = document.querySelector(`[data-value="${t.defaultValue ? t.defaultValue : this.element.value}"]`) ? document.querySelector(`[data-value="${t.defaultValue ? t.defaultValue : this.element.value}"]`) : document.querySelector(`.${t.defaultValue ? t.defaultValue : this.element.value}`),
          n = (_e$dataset$value = e === null || e === void 0 ? void 0 : e.dataset.value) !== null && _e$dataset$value !== void 0 ? _e$dataset$value : "";
        e !== null && e !== void 0 && e.classList.add("is-selected"), i = e, this.currentlySelectName = n, this.element.value || this._setValueInput();
      }
    }
    async _getIcons() {
      const e = this.options,
        t = [];
      let i = h(e.iconSource);
      for (const e of Object.values(i)) t.push(e.url);
      return await Promise.all(t.map(e => fetch(e).then(e => e.json()))).then(e => (e.forEach(e => {
        i.hasOwnProperty(e.prefix) && (e.prefix = i[e.prefix].prefix);
      }), e));
    }
    _catchError(e) {
      if ("iconSourceMissing" === e) throw Error("No icon source was found.");
    }
    _setValueInput() {
      let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.currentlySelectName;
      const t = this.element;
      t instanceof HTMLInputElement && this.currentlySelectName && (t.value = e);
    }
  }
  return t = t.default;
})());